































































































































































































































































































import EdicaoGenerica from '@/components/layout/EdicaoGenerica.vue';
import DialogoDeBuscaDeVendedor from '@/components/metas/DialogoDeBuscaDeVendedor.vue';
import AvatarDeUsuario from '@/components/usuario/AvatarDeUsuario.vue';
import { Meta, Usuario } from '@/models';
import { criarMeta } from '@/shareds/meta/meta-shareds';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { UsuariosModule } from '@/store/vuex/usuario/UsuariosStore';
import { FindMetasUseCase } from '@/usecases';
import { FindUsuarioUseCase } from '@/usecases/usuario';
import { SaveMetaUseCase } from '@/usecases/meta/SaveMetaUseCase';
import { nextTick } from '@/shareds/utils'
import { Ref, Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { DeleteMetaUseCase } from '@/usecases/meta/DeleteMetaUseCase';
import { MetaModule } from '@/store/vuex/meta/MetaStore';
import { obrigatorio } from '@/shareds/regras-de-form';
import Confirmacao from '@/components/ui/Confirmacao.vue';
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue';
import { Operador } from '@/models/venda/Operador';
import DialogoMetaDiaria from '@/components/metas/DialogoMetaDiaria.vue';
import { DeleteMetaDiariaUseCase } from '@/usecases/metaDiaria/DeleteMetaDiariaUseCase';
import { FindMetaDiariaUseCase } from '@/usecases/metaDiaria/FindMetaDiariaUseCase';
import DialogoDeCsvDeMetas from './DialogoDeCsvDeMetas.vue';
import DialogoDeDistribuicaoDeMetaDiaria from './DialogoDeDistribuicaoDeMetaDiaria.vue';

@Component({
	components: {
		EdicaoGenerica,
		DialogoDeBuscaDeVendedor,
		AvatarDeUsuario,
		Confirmacao,
		SeletorDeLojasDoUsuario,
		DialogoMetaDiaria,
		DialogoDeCsvDeMetas,
		DialogoDeDistribuicaoDeMetaDiaria,
	},
})
export default class EdicaoDeMetas extends Vue {
	@Ref() edicaoGenerica!: EdicaoGenerica<Meta>
	@Ref() confirmacao!: Confirmacao
	@Prop({ type: String }) id!: string
	@Prop({ type: Boolean }) novo!: boolean
	@Ref() dialogoDeCsvDeMetas!: DialogoDeCsvDeMetas
	@Ref() dialogoDistribuicao!: DialogoDeDistribuicaoDeMetaDiaria

	meta: Meta | null = null
	valorDisplay = ''
	superMetaDisplay = ''
	saveUseCase = new SaveMetaUseCase()
	findUseCase = new FindMetasUseCase()
	deleteUseCase = new DeleteMetaUseCase()
	deleteMetaDiariaUseCase = new DeleteMetaDiariaUseCase()
	versaoAnterior: Meta | null = null

	mostrarDialogoMetaDiaria = false
	vendedorSelecionado: Operador | null = null

	obrigatorio = obrigatorio
	carregando = false
	respostaConfirmacao = false
	salvando = false
	adicionandoTodos = false
	findUsuariosUseCase = new FindUsuarioUseCase()
	findMetaDiariaUseCase = new FindMetaDiariaUseCase()
	resumoMensal: Record<string, { total: number; carregando: boolean }> = {}
	$router: any;

	async salvar() {
		if (!this.meta) return
		if (!this.meta.ativarMeta && this.meta.vendedorAtribuido.length > 0 && !this.respostaConfirmacao) {
			this.respostaConfirmacao = true
			this.confirmacao.mostrar()
			return
		}
		if (!this.meta.lojaId) {
			AlertModule.setInfo('Selecione a loja')
			return
		}
		try {
			this.salvando = true
			const metaSalva = await this.saveUseCase.update({ ...this.meta })
			this.id
				? MetaModule.atualizaMeta(metaSalva)
				: MetaModule.adicionaMeta(metaSalva)
			AlertModule.setSuccess('Meta salva com sucesso!')
			if (this.novo) {
				this.$router.push({ name: 'Meta', params: { id: metaSalva.id } })
			}
			this.versaoAnterior = JSON.parse(JSON.stringify(this.meta))
			MetaModule.atualizarFiltro(true)
		} catch (error: any) {
			AlertModule.setError(error)
			this.respostaConfirmacao = false
		} finally {
			this.salvando = false
			this.respostaConfirmacao = false
			this.carregar()
		}
	}

	inserirVendedor(usuario: Usuario) {
		if (!this.meta) return
		if (!this.meta.ativarMeta) {
			AlertModule.setError('Meta precisa estar ativa para adicionar vendedor')
			return
		}
		if (!this.meta.lojaId) {
			AlertModule.setInfo('Selecione a loja antes de adicionar vendedores')
			return
		}
		if (this.meta.vendedorAtribuido.some(({ id }) => usuario.id === id)) {
			AlertModule.setError(`${usuario.nome} já está atribuído à meta`)
			return
		}
		const vendedor: Usuario = {
			...usuario,
			senha: usuario.senha || '',
			lojas: [],
			pdvs: [],
			cpf: usuario.cpf || null,
			email: usuario.email || null,
			vendedor: usuario.vendedor || false,
		}
		this.meta.vendedorAtribuido.push(vendedor)
	}

	async desvincularVendedor() {
		if (!this.meta) return
		this.meta.vendedorAtribuido = []
		try {
			await this.deleteMetaDiariaUseCase.deleteMeta(this.meta.id)
		} catch {
			// sem metas diárias vinculadas — pode ignorar
		}
		this.salvar()
	}

	apenasNumericos(e: KeyboardEvent) {
		if (!/[\d,]/.test(e.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
			e.preventDefault()
		}
	}

	formatarValor() {
		const cleaned = this.valorDisplay.replace(/\./g, '').replace(',', '.')
		const num = parseFloat(cleaned) || 0
		if (this.meta) this.meta.valor = num
		this.valorDisplay = num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
	}

	formatarSuperMeta() {
		const cleaned = this.superMetaDisplay.replace(/\./g, '').replace(',', '.')
		const num = parseFloat(cleaned) || 0
		if (this.meta) this.meta.superMeta = num || null
		this.superMetaDisplay = num ? num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
	}

	private atualizarValorDisplay() {
		const v = this.meta?.valor ?? 0
		this.valorDisplay = v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		const s = this.meta?.superMeta ?? null
		this.superMetaDisplay = s ? s.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
	}

	async carregar() {
		try {
			this.carregando = true
			const meta = this.novo ? criarMeta() : await this.findUseCase.findById(this.id)
			this.meta = meta
			this.atualizarValorDisplay()
			nextTick().then(() => {
				this.versaoAnterior = JSON.parse(JSON.stringify(this.meta))
			})
			MetaModule.setMetaSelecionada(this.meta)
			this.carregarResumoMensal()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.$nextTick(() => { this.carregando = false })
		}
	}

	displayPerfilTooltip(id: string) {
		const perfil = UsuariosModule.perfil(id)
		return perfil ? `${perfil.nome} — ` : ''
	}

	removerVendedorDaMeta(id: string) {
		if (!this.meta) return
		this.meta.vendedorAtribuido = this.meta.vendedorAtribuido.filter(u => u.id !== id)
		this.deleteMetaDiariaUseCase.deleteUsuarioMeta(this.meta.id, id).catch(error => {
			AlertModule.setError(error)
		})
	}

	async adicionarTodos() {
		if (!this.meta?.lojaId) return
		try {
			this.adicionandoTodos = true
			let pageNum = 0
			let adicionados = 0
			while (true) {
				const page = await this.findUsuariosUseCase.findAllVendedores({
					page: pageNum,
					size: 50,
					somenteVendedor: true,
					somenteUsuariosAtivos: true,
					lojas: [this.meta.lojaId],
				})
				for (const vendedor of page.content) {
					if (!this.meta.vendedorAtribuido.some(v => v.id === vendedor.id)) {
						this.inserirVendedor(vendedor)
						adicionados++
					}
				}
				if (page.last) break
				pageNum++
			}
			if (adicionados === 0) AlertModule.setInfo('Todos os vendedores ativos já estão atribuídos.')
			else AlertModule.setSuccess(`${adicionados} vendedor${adicionados !== 1 ? 'es' : ''} adicionado${adicionados !== 1 ? 's' : ''}.`)
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.adicionandoTodos = false
		}
	}

	get mesAtualLabel(): string {
		const agora = new Date()
		return agora.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
	}

	formatarMoeda(valor: number): string {
		return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 })
	}

	progressoVendedor(vendedorId: string): number {
		if (!this.meta?.valor) return 0
		const resumo = this.resumoMensal[vendedorId]
		if (!resumo || resumo.carregando) return 0
		return Math.min(100, (resumo.total / this.meta.valor) * 100)
	}

	async carregarResumoMensal() {
		if (!this.meta?.id || !this.meta.vendedorAtribuido.length) return
		const agora = new Date()
		const ano = agora.getFullYear()
		const mes = String(agora.getMonth() + 1).padStart(2, '0')
		const ultimoDia = new Date(agora.getFullYear(), agora.getMonth() + 1, 0).getDate()
		const start = `${ano}-${mes}-01`
		const end = `${ano}-${mes}-${String(ultimoDia).padStart(2, '0')}`
		for (const vendedor of this.meta.vendedorAtribuido) {
			this.$set(this.resumoMensal, vendedor.id, { total: 0, carregando: true })
			this.findMetaDiariaUseCase.findByUserAndRange(this.meta.id, vendedor.id, start, end)
				.then(metas => {
					const total = metas.reduce((sum, m) => sum + (m.valor || 0), 0)
					this.$set(this.resumoMensal, vendedor.id, { total, carregando: false })
				})
				.catch(() => {
					this.$set(this.resumoMensal, vendedor.id, { total: 0, carregando: false })
				})
		}
	}

	@Watch('id', { immediate: true })
	onChangeId() {
		this.carregar()
	}

	@Watch('meta.valor')
	onValorChange(newVal: number) {
		if (!this.meta) return
		const superMeta = this.meta.superMeta
		if (superMeta == null || superMeta < newVal) {
			this.meta.superMeta = newVal || null
			const s = this.meta.superMeta
			this.superMetaDisplay = s ? s.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
		}
	}

	abrirDialogoMetaDiaria(funcionario: Operador) {
		if (!this.meta?.id) {
			AlertModule.setError('Salve a meta antes de adicionar meta diária ao vendedor')
			return
		}
		this.vendedorSelecionado = funcionario
		this.mostrarDialogoMetaDiaria = true
	}

	abrirDialogoDistribuicao() {
		if (!this.meta?.id) {
			AlertModule.setInfo('Salve a meta antes de distribuir.')
			return
		}
		this.dialogoDistribuicao.mostrar(this.meta.id)
	}

	abrirDialogoImportacao() {
		if (!this.meta?.id) {
			AlertModule.setInfo('Salve a meta antes de importar.')
			return
		}
		this.dialogoDeCsvDeMetas.mostrar(this.meta.id, this.meta.descricao ?? undefined, this.meta.vendedorAtribuido)
	}

	get lojas(): string[] {
		return this.meta?.lojaId ? [this.meta.lojaId] : []
	}
}
